var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"left":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('a',_vm._g({attrs:{"id":'download_'+_vm.id,"href":"/","download":""}},on),[_c('v-icon',{staticClass:"mt-n1"},[_vm._v("mdi-cloud-download")])],1)]}}])},[_c('span',[_vm._v(_vm._s(_vm.$vuetify.lang.t('$vuetify.tooltips.ButtonIcon')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }